import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import {
  deleteAttachFileService,
  getAttachFileService,
  searchAttachFileService,
  UpdateAttach,
  UploadAttach,
} from "../api/AttachfileApi";
import { handleApiError } from "../api/InstanceApi";
import { useIntl } from "react-intl";

export const useGetAttachFile = (limit = 5, page = 1) => {
  return useQuery({
    queryKey: ["attach", limit, page],
    queryFn: () => getAttachFileService({ limit, page }),
  });
};

export const useDeleteAttachMutation = () => {
  const intl = useIntl();
  return useMutation({
    mutationFn: async (id) => {
      return await toast.promise(deleteAttachFileService({ id }), {
        pending: {
          render() {
            return `${intl.formatMessage({ id: 'ATTACH_FILES.DELETING' })}`;
          },
        },
        success: {
          render() {
            return `${intl.formatMessage({ id: 'ATTACH_FILES.DELETED' })}`;
          },
        },
        error: {
          render({ data }) {
            return `${intl.formatMessage({ id: 'ATTACH_FILES.DELETE_ERROR' })}`;
          },
        },
      });
    },
    onError: (data) => handleApiError(data),
  });
};

export const useSearchAttachFile = (searchParams) => {
  return useQuery({
    queryKey: [
      "attach-search",
      searchParams?.limit,
      searchParams?.page,
      searchParams?.name,
    ],
    queryFn: () => searchAttachFileService(searchParams),
    staleTime: 0,
  });
};

export const useUploadAttach = () => {
  const intl = useIntl();
  return useMutation({
    mutationFn: async ({ file, name, detail }) => {
      return await toast.promise(
        UploadAttach({ data: { file, name, detail } }),
        {
          pending: {
            render() {
              return `${intl.formatMessage({ id: 'ATTACH_FILES.UPLOADING' })}`;
            },
          },
          success: {
            render() {
              return `${intl.formatMessage({ id: 'ATTACH_FILES.UPLOADED' })}`;
            },
          },
          error: {
            render({ data }) {
              return `${intl.formatMessage({ id: 'ATTACH_FILES.UPLOAD_ERROR' })}`;
            },
          },
        }
      );
    },
    onError: (data) => handleApiError(data),
  });
};

export const useUpdateAttach = () => {
  return useMutation({
    mutationFn: async (payload) => {
      return await toast.promise(UpdateAttach(payload), {
        pending: {
          render() {
            return "Đang cập nhật...";
          },
        },
        success: {
          render() {
            return "Cập nhật thành công!";
          },
        },
        error: {
          render({ data }) {
            return data.message;
          },
        },
      });
    },
    onError: (data) => handleApiError(data),
  });
};
